import styled from 'styled-components'
import { tokens } from 'styling/tokens'

export const LineCard = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 1rem;
  border: 1px solid ${tokens.border.hairline};
  border-radius: ${tokens.radius.card};
`
